export default "__VITE_ASSET__$_ZNdoK8__"